import type { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { cn } from '../../lib/cn';
import type { AuditRowState } from '../../lib/auditStudioDerived';

export type SubmissionTrustState = 'draft' | 'finalized';

export function auditRowToTrustState(state: AuditRowState): SubmissionTrustState {
  return state === 'ready' ? 'finalized' : 'draft';
}

type SubmissionStateBadgeProps = {
  state: SubmissionTrustState;
  synced?: boolean;
  className?: string;
};

export function SubmissionStateBadge({
  state,
  synced = false,
  className,
}: SubmissionStateBadgeProps): ReactElement {
  const { t } = useTranslation();
  const label = state === 'draft' ? t('trust.submission.draft') : t('trust.submission.finalized');

  return (
    <span className={cn('inline-flex flex-wrap items-center gap-1.5', className)}>
      <span
        className={cn(
          'inline-flex shrink-0 rounded-full border px-2.5 py-0.5 text-dg-label font-medium uppercase tracking-wide',
          state === 'draft' &&
            'border-dg-accent-grade/25 bg-dg-accent-gradeLight/70 text-amber-900 dark:border-amber-700/35 dark:bg-amber-950/25 dark:text-amber-100',
          state === 'finalized' &&
            'border-emerald-500/20 bg-emerald-50/90 text-emerald-800 dark:border-emerald-700/35 dark:bg-emerald-950/30 dark:text-emerald-200'
        )}
      >
        {label}
      </span>
      {synced ? (
        <span className="inline-flex shrink-0 rounded-full border border-slate-200/70 bg-slate-50/90 px-2 py-0.5 text-dg-label font-medium uppercase tracking-wide text-slate-600 dark:border-slate-600 dark:bg-slate-800/50 dark:text-slate-300">
          {t('trust.submission.synced')}
        </span>
      ) : null}
    </span>
  );
}
